export function cplFormSubmissionErrorHandler(err: any): void {
  const error = err.details && err.details[0];
  if (!(error?.context?.validator === "unique" && error?.path[0] === "email")) {
    throw new Error(`CPL form submission error: ${err}`);
  }
}
